import { useState, useEffect, useCallback } from 'react';
import { fetchDomainTree } from '../services/taxonomyApi';
import { transformDomainTreeToFlow, buildTermsMap } from '../utils/taxonomyTransformer';

const useTaxonomy = () => {
	const [domainTree, setDomainTree] = useState([]);
	const [taxonomyFlow, setTaxonomyFlow] = useState(null);
	const [termsMap, setTermsMap] = useState({});
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	useEffect(() => {
		const load = async () => {
			try {
				const data = await fetchDomainTree();
				setDomainTree(data);
				setTaxonomyFlow(transformDomainTreeToFlow(data));
				setTermsMap(buildTermsMap(data));
			} catch (err) {
				setError(err);
			} finally {
				setLoading(false);
			}
		};
		load();
	}, []);

	const getTermById = useCallback(
		(termId) => termsMap[termId] || null,
		[termsMap]
	);

	return { domainTree, taxonomyFlow, getTermById, loading, error };
};

export default useTaxonomy;
